module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "purple--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Authorization callback for " + _vm._s(_vm.provider) + " ...")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2489b58a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CallbackProvider.vue
// module id = 389
// module chunks = 0